import { getCMServiceConfiguration } from '../../../firebase/cloudFunction'
import { useGetTenantId } from 'hooks/useGetTenantId'
import { createContext, useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const CMSContext = createContext()

export const CMSContextProvider = ({ children }) => {
  const tenantId = useGetTenantId()
  const [cmConfig, setCMConfig] = useState({
    serviceStatus: false,
    maxUploadStorage: 0,
    maxDownloadStorage: 0,
  })

  useEffect(() => {
    getCMServiceConfiguration(tenantId)
      .then((response) => {
        if (response?.success) {
          const config = response?.config
          setCMConfig(config)
        }
      })
      .catch((error) => console.log(error))
  }, [tenantId])

  return <CMSContext.Provider value={cmConfig}>{children}</CMSContext.Provider>
}

CMSContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useCMSContext = () => useContext(CMSContext)
